import React, { useState } from "react";
import DatePickerComponent from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./styles.scss";

import { FiCalendar } from "react-icons/fi";
import { pt } from "date-fns/locale";
import moment from "moment";

const MonthYearPicker = ({ placeholder, onChange }) => {
  const [value, setValue] = useState(null);

  const handleChange = (date) => {
    setValue(date);
    const formattedDate = moment(date).format("MM/yyyy");
    onChange(formattedDate);
  };

  return (
    <div className="month-year-picker">
      <DatePickerComponent
        selected={value}
        onChange={handleChange}
        dateFormat="MM/yyyy"
        placeholderText={placeholder}
        showMonthYearPicker
        className="form-control"
        locale={pt}
        maxDate={new Date()}
      />
      <FiCalendar className="date-icon" />
    </div>
  );
};

export default MonthYearPicker;